import type { ComponentType } from "react";
import { createRoot } from "react-dom/client";
import "./application.css";
import { HydrationCheck } from "@/components/HydrationCheck";
import { MarkdownEditor } from "@/components/MarkdownEditor";
import { selectPublishModeOnDateEntry } from "@/lib/publishMode";

// Props cross from Rails as untyped JSON, so the registry is deliberately loose
// here; each component re-asserts its own prop types at its boundary.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const COMPONENTS: Record<string, ComponentType<any>> = {
  HydrationCheck,
  MarkdownEditor,
};

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll<HTMLElement>("[data-react-component]")
    .forEach((node) => {
      const name = node.dataset.reactComponent;
      const Component = name ? COMPONENTS[name] : undefined;

      if (!Component) {
        console.error(`No React component registered for "${name}"`);
        return;
      }

      createRoot(node).render(
        <Component {...JSON.parse(node.dataset.reactProps ?? "{}")} />,
      );
    });
});

selectPublishModeOnDateEntry();
